export default [
    {
        path: '/jobs',
        name: 'Jobs',
        component: () => import('../../views/Jobs.vue')
    },
    {
        path: '/job/:id',
        name: 'JobDetail',
        props: true,
        component: () => import('../../views/JobDetail.vue')
    }
]
